export * from './prices';
export * from './great-price.component';
export * from './great-price.module';
